<template>
  <div class="app">
    <KioskModal
      v-if="showKioskModal"
      @confirm="onKioskConfirm"
      @dismiss="showKioskModal = false"
    />
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouterView } from 'vue-router';
import KioskModal from './components/KioskModal.vue';
import { useKioskMode } from './composables/useKioskMode.ts';

const showKioskModal = ref(true);
const { enableKiosk } = useKioskMode();

function onKioskConfirm(): void {
  showKioskModal.value = false;
  enableKiosk().catch((err: unknown) => {
    console.warn('[app] Kiosk mode failed:', err);
  });
}
</script>

<style>
/* Global reset */
*, *::before, *::after {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  background: #f3f4f6;
  color: #111827;
}

@media (prefers-color-scheme: dark) {
  html, body {
    background: #111827;
    color: #f9fafb;
  }
}

#app {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>

<style scoped>
.app {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>
